export const HEADERS = [
  'HEADER.ID',
  'HEADER.USER',
  'HEADER.PERIOD_START',
  'HEADER.PERIOD_END',
  'HEADER.CODE',
  'HEADER.INVOICE',
  'HEADER.CREATED',
];
